import { FilterMenuConfig } from '../../types/filter.type';

export const STATUS_FILTERS: FilterMenuConfig = {
  sortMode: 'alphabetic',
  sortable: false,
  filters: [
    {
      type: 'checkbox',
      data: [
        {
          icon: 'lock',
          label: 'publication_block.visibility.private',
          value: 'private',
        },
        {
          icon: 'language',
          label: 'publication_block.visibility.public',
          value: 'public',
        },
      ],
    },
  ],
};
